// extracted by mini-css-extract-plugin
module.exports = {"carousel":"CarouselImages_carousel__3AuNH"};